import SystemError from '../components/SystemError';
import { useContext, useEffect } from 'react';
import UserContext from '../store/User/UserContext';
import { useNavigate } from 'react-router-dom';

const ErrorPage = () => {
    const navigate = useNavigate();
    const user = useContext(UserContext);

    useEffect(() => {
        if (user) {
            navigate('/dashboard');
        }
    }, [navigate, user]);

    return <SystemError />;
};

export default ErrorPage;
